import { isVerifyEmailPath } from '@/apps/verifyEmail/helpers/paths';

export type EmailVerificationBannerOptions = {
  /** Variant B (and A fallback): force the banner even when GraphQL showBanner is false. */
  forceShow?: boolean;
};

/**
 * Client-side route gating for the persistent email-verification banner.
 * Eligibility comes from GraphQL `showBanner` (existing soft-prompt cohort) and/or
 * a parent-experiment hard-gate (`forceShow`). This only hides the banner on
 * surfaces where authenticated nav chrome is not the focus.
 */
export function shouldShowEmailVerificationBanner(
  showBanner: boolean,
  currentPath: string,
  options: EmailVerificationBannerOptions = {}
): boolean {
  if (!showBanner && !options.forceShow) {
    return false;
  }

  if (isVerifyEmailPath(currentPath)) {
    return false;
  }

  const excludedRoutes = ['/registration', '/upgrade', '/bh-benefits', '/job-post'];
  if (excludedRoutes.some((route) => currentPath.startsWith(route))) {
    return false;
  }

  return true;
}

export default shouldShowEmailVerificationBanner;
